import { __extends } from "tslib";
import { PutBucketRequestPaymentRequest } from "../models/index";
import { deserializeAws_restXmlPutBucketRequestPaymentCommand, serializeAws_restXmlPutBucketRequestPaymentCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutBucketRequestPaymentCommand = /** @class */ (function (_super) {
    __extends(PutBucketRequestPaymentCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutBucketRequestPaymentCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutBucketRequestPaymentCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: PutBucketRequestPaymentRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutBucketRequestPaymentCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutBucketRequestPaymentCommand(input, context);
    };
    PutBucketRequestPaymentCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutBucketRequestPaymentCommand(output, context);
    };
    return PutBucketRequestPaymentCommand;
}($Command));
export { PutBucketRequestPaymentCommand };
//# sourceMappingURL=PutBucketRequestPaymentCommand.js.map